import BaseModelAPI from '../BaseModelAPI';

export default class BillOfProcessPartTypeList extends BaseModelAPI {

	static entity = 'billofprocessparttypelist'
	static entityName = 'billofprocessparttype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
